import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { Input, Tooltip } from '@salesforce/design-system-react';

import './Tagging.scss';

const DEFAULT_CONFIDENCE = 60;
const MIN_CONFIDENCE = 50;
const MAX_CONFIDENCE = 100;

const DEFAULT_TAG_NUM = 10;
const MIN_TAG = 1;
const MAX_TAG = 10;

class Tagging extends Component {
  defaults(field) {
    switch (field) {
      case 'min_confidence':
        return DEFAULT_CONFIDENCE;
      case 'tag_num':
        return DEFAULT_TAG_NUM;
      default:
    }
  }
  /**
   * Gets the current value that should go into an input control for a given field
   */
  selectedTagSetting(field) {
    switch (field) {
      case 'min_confidence':
        let confidence;
        if (this.props.ect_min_confidence_level) {
          confidence = Number.parseFloat(this.props.ect_min_confidence_level);
          if (confidence < 1.1) {
            confidence = Math.round(confidence * 100, 0);
          }
        } else {
          confidence = this.defaults(field);
        }
        return confidence;
      case 'tag_num':
        return this.props.ect_max_tags
          ? this.props.ect_max_tags
          : this.defaults(field);
      default:
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <div className="tagging slds-grid">
        <div className="slds-col slds-size_1-of-5">
          <Input
            label={formatMessage({
              id: 'components.ecs.rules.tagging.minConfidence'
            })}
            disabled={!this.props.isTagging}
            value={this.selectedTagSetting('min_confidence')}
            minValue={MIN_CONFIDENCE}
            maxValue={MAX_CONFIDENCE}
            step={10}
            variant="counter"
            onChange={(event, { value }) =>
              this.props.onSettingChanged('ect_min_confidence_level', value)
            }
            fieldLevelHelpTooltip={
              <Tooltip
                id="minConfidence-tooltip"
                align="right"
                content={formatMessage({
                  id: 'components.ecs.rules.tagging.minConfidenceTooltip'
                })}
              />
            }
          />
        </div>
        <div className="slds-col slds-size_2-of-5">
          <Input
            label={formatMessage({
              id: 'components.ecs.rules.tagging.maxTags'
            })}
            disabled={!this.props.isTagging}
            value={this.selectedTagSetting('tag_num')}
            minValue={MIN_TAG}
            maxValue={MAX_TAG}
            variant="counter"
            onChange={(event, { value }) =>
              this.props.onSettingChanged('ect_max_tags', value)
            }
            fieldLevelHelpTooltip={
              <Tooltip
                id="maxTags-tooltip"
                align="right"
                content={formatMessage({
                  id: 'components.ecs.rules.tagging.maxTagsTooltip'
                })}
              />
            }
          />
        </div>
      </div>
    );
  }
}

Tagging.propTypes = {
  isTagging: PropTypes.bool,
  ect_min_confidence_level: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  ect_max_tags: PropTypes.number,
  onSettingChanged: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(Tagging);
